import { Alert } from '@mui/material'

import { form } from '../../../../formState'
import { useTexts } from '../../hooks/useTexts'
import { InfoBanner } from './components/InfoBanner'

const MIN_AREA_POINTS = 3

export function DrawArea() {
  const texts = useTexts()
  const { errors, field } = form.useFormField('points')

  form.useAddFieldValidation<'points'>('points', (field, _formApi) => {
    if (field.value.length < MIN_AREA_POINTS) {
      return texts.errorPoints
    }

    return undefined
  })

  return (
    <form.Fieldset>
      <form.DrawAreaField
        name="points"
        drawAreaProps={{
          id: 'trafficArea',
          color: '#f00',
          initialPoints: field.value,
        }}
      />

      <InfoBanner />

      {errors.length > 0 && (
        <Alert severity="error" component="div">
          {errors[0].message}
        </Alert>
      )}
    </form.Fieldset>
  )
}
